import { ChangeDetectorRef, Component, inject, Input, Output, EventEmitter, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppUtils } from '../../utlis/app-utils';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { statusIcon } from '../../constants';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { NotificationFilterService } from '../notification-filter/notification-filter.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'dl-notification-table',
  standalone: true,
   imports: [OneWebComponentsAngularModule,CommonModule],
  templateUrl: './notification-table.component.html',
  styleUrl: './notification-table.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationTableComponent implements OnDestroy {
  appUtils = inject(AppUtils); 
  router = inject(Router); 
  changeDetect = inject(ChangeDetectorRef); 
  qnSbnService = inject(QnSbnService); 
  qnSbnDataService = inject(QnSbnDataServiceService);
  @Input() tableData: any[] = [];
  @Input() filterOptSel: { types: string[]; statuses: string[], country: string[] } 
  @Input() searchValueSel:string = '';
  @Output() filterOptionsExtracted = new EventEmitter<{ types: string[], statuses: string[], country: string[] }>();
  
  initPageLoad = false;
  filterBool = false;
  searchBool = false;
  previousAccSel: any;
  previousOptSel: any;
  previousSearchSel: any;
  previoustableData: any;
  ogTableData: any;
  spinBool = false;
  usingCachedData = false; // Flag to prevent ngOnChanges from overwriting filtered cached data
  cachedDataLocked = false; // Lock to prevent updatePaginatedData from being called after cached data is set

  // Pagination properties
  paginatedData: any[] = [];
  currentPage = 0;
  pageSize = 10; // Default to first option in pageSizeOptions
  pageSizeOptions = [10, 25, 50, 100, 250, 500];
  totalCount = 0;
  sortInfo: { column: string, direction: string }[] = [{ column: 'DateDelivered', direction: 'desc' }];
  dd:any;
  public userPermission: any;
  public notificationStatusIcon: {};
  private initialLoadDone = false;
  private destroy$ = new Subject<void>();
  private currentTableDataSubscription: any;

  constructor(private notificationFilterService: NotificationFilterService, ){}

  ngOnDestroy(): void {
    // Unsubscribe from all observables to prevent memory leaks
    this.destroy$.next();
    this.destroy$.complete();
    if (this.currentTableDataSubscription) {
      this.currentTableDataSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges){
    let filterTriggered = false;
    
    // If filter is being changed, reset the cached data flag and apply filter
    if (changes['filterOptSel'] && changes['filterOptSel'].currentValue !== this.previousOptSel) {
      this.usingCachedData = false; // Allow filter changes to work
      this.cachedDataLocked = false; // Unlock to allow updates
      this.previousOptSel = changes['filterOptSel'].currentValue;
      this.filterOptSelected(this.filterOptSel);
      filterTriggered = true;
    }
    
    // If search is being changed, reset the cached data flag
    if (changes['searchValueSel'] && changes['searchValueSel'].currentValue !== this.previousSearchSel) {
      this.usingCachedData = false; // Allow search to work
      this.cachedDataLocked = false; // Unlock to allow updates
      this.previousSearchSel = changes['searchValueSel'].currentValue;
      this.searchInput(this.searchValueSel || '');
    }
    
    // Skip tableData changes if we're using cached data (to prevent overwriting filtered results)
    if (changes['tableData'] && changes['tableData'].currentValue !== this.previoustableData) {
     
      if (this.usingCachedData) {
       
      } else {
       
        this.tableData = this.applySorting(this.tableData);
        this.previoustableData = changes['tableData'].currentValue;
        this.ogTableData = [...this.tableData];
        this.spinBool = false;
        this.currentPage = 0; // Reset to first page
        this.updatePaginatedData();
        if(this.tableData?.length < 1) {
          this.initPageLoad = true;
        }else{
          this.initPageLoad = false;
        }
      }
    }
    
    // Mark initial load done if filter triggered
    if (filterTriggered) {
      this.initialLoadDone = true;
    }
  }

  ngOnInit(): void {
    this.notificationStatusIcon = statusIcon;
    this.userPermission = this.qnSbnService.getUserData();
    const allNotificationData = this.qnSbnService.getNotificationData();
    this.sortInfo = [{ column: 'CreationDate', direction: 'desc' }];
    
    // Check if we should reload or use cached data
    const shouldReload = sessionStorage.getItem('reloadOverview') === 'true';
    const hasCachedData = allNotificationData && 
                          allNotificationData.notificationOverview && 
                          Array.isArray(allNotificationData.notificationOverview) &&
                          allNotificationData.notificationOverview.length > 0;
    
  
    
    if(shouldReload || !hasCachedData) {
      
      this.usingCachedData = false; // Reset flag when making API call
      this.cachedDataLocked = false; // Unlock when making API call
      
      // Get array of selected values
      const typeValues = this.notificationFilterService.typeFilStore.map(opt => opt.value) || ['all'];
      const statusValues = this.notificationFilterService.statusFilStore.map(opt => opt.value) || ['all'];
      const countryValues = this.notificationFilterService.countryFilStore.map(opt => opt.value) || ['all'];

      // Use them for filtering
      if (typeValues.length || statusValues.length || countryValues.length) {
        this.getTableData(typeValues.length ? typeValues : ['all'],
                          statusValues.length ? statusValues : ['all'],
                          countryValues.length ? countryValues : ['all']);
      } else {
        this.getTableData(['all'], ['all'], ['all']);
      }
      sessionStorage.setItem('reloadOverview', 'false');
    } else {
     
      this.usingCachedData = true; // Set flag to prevent ngOnChanges from overwriting
      
      // Use cached data without API call
      // Try to get full unfiltered data first
      const fullDataStr = sessionStorage.getItem('fullUnfilteredData');
      let sourceData = allNotificationData;
      
      if (fullDataStr) {
        try {
          sourceData = JSON.parse(fullDataStr);
        
        } catch (e) {
         
        }
      } else {
     
      }
      
      this.tableData = sourceData.notificationOverview || [];
      this.ogTableData = [...this.tableData];
      
      
      // Apply stored filters to cached data
      const typeValues = this.notificationFilterService.typeFilStore.map(opt => opt.value) || [];
      const statusValues = this.notificationFilterService.statusFilStore.map(opt => opt.value) || [];
      const countryValues = this.notificationFilterService.countryFilStore.map(opt => opt.value) || [];
      
    
      
      // Filter the data if filters are applied
      if (typeValues.length > 0 || statusValues.length > 0 || countryValues.length > 0) {
       
        this.tableData = this.tableData.filter(item => {
          const typeMatch = typeValues.length === 0 || typeValues.includes(item.Type);
          const statusMatch = statusValues.length === 0 || statusValues.includes(item.Status);
          const countryMatch = countryValues.length === 0 || countryValues.includes(item.Country);
          return typeMatch && statusMatch && countryMatch;
        });
       
      }
      
      this.tableData = this.applySorting(this.tableData);
      this.currentPage = 0;
      this.updatePaginatedData();
    
      
      // Lock the cached data to prevent any further updates
      this.cachedDataLocked = true;
      
      // Force Angular to detect changes
      this.changeDetect.detectChanges();
      
      // Extract and emit filter options to parent from full unfiltered data
      const filterOptions = this.extractFilterOptions(this.ogTableData);
      this.filterOptionsExtracted.emit(filterOptions);
      
      if(this.tableData?.length < 1) {
        this.initPageLoad = true;
      } else {
        this.initPageLoad = false;
      }
    }
  }

  filterOptSelected(filterValue: any) {
    // Defensive: always use arrays for filters
    const typeFilters = Array.isArray(filterValue?.typeFilters) && filterValue.typeFilters.length > 0 ? filterValue.typeFilters : ['all'];
    const statusFilters = Array.isArray(filterValue?.statusFilters) && filterValue.statusFilters.length > 0 ? filterValue.statusFilters : ['all'];
    const countryFilters = Array.isArray(filterValue?.countryFilters) && filterValue.countryFilters.length > 0 ? filterValue.countryFilters : ['all'];
    this.getTableData(typeFilters, statusFilters, countryFilters);
  }

   public getTableData(type, status, country){
    // Cancel any previous request
    if (this.currentTableDataSubscription) {
      this.currentTableDataSubscription.unsubscribe();
    }

    this.currentTableDataSubscription = this.qnSbnService.getNotificationOverviewData(type, status, country)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {      
          // Always cache the data received from API
          this.qnSbnService.setNotificationData(data);
          
          // If this is the initial load with no filters, also store as full unfiltered data
          if ((type.length === 1 && type[0] === 'all') && 
              (status.length === 1 && status[0] === 'all') && 
              (country.length === 1 && country[0] === 'all')) {
            sessionStorage.setItem('fullUnfilteredData', JSON.stringify(data));
          }
          
          // @ts-ignore
          this.tableData = data.notificationOverview;
          this.ogTableData = this.tableData;
          this.tableData = this.applySorting(this.tableData);
          this.currentPage = 0; // Reset to first page when filtering
          this.updatePaginatedData(); // Update paginated data after filtering
          
          // Extract and emit filter options to parent
          const filterOptions = this.extractFilterOptions(this.tableData);
          this.filterOptionsExtracted.emit(filterOptions);
          
          this.tableData.forEach(value => {
            this.notificationFilterService.setTypeName(value.Type);
            this.notificationFilterService.setStatusName(value.Status);
            this.notificationFilterService.setStatusName('Completed');
            this.notificationFilterService.setCountryName(value.Country);
          });
          
          if(this.tableData.length < 1) {
            this.initPageLoad = true;
          } else {
            this.initPageLoad = false;
          }
          
          this.changeDetect.detectChanges();
        },
        (error: HttpErrorResponse) => {
          console.error('Error fetching notification data:', error);
          
          // Handle different error scenarios
          if (error.status === 401) {
            // Unauthorized - session expired
            this.qnSbnService.httpErrorHandler(error, 'Your session has expired. Please login again.');
            // Redirect to login
            setTimeout(() => {
              window.location.href = '/login';
            }, 2000);
          } else if (error.status === 0 || error.status === 408) {
            // Network error or timeout
            this.qnSbnService.httpErrorHandler(error, 'Connection timeout. Please check your internet connection and try again.');
            this.initPageLoad = true;
          } else {
            this.qnSbnService.httpErrorHandler(error, 'Failed to load notifications. Please try again.');
            this.initPageLoad = true;
          }
        }
      );
  }
  
  private extractFilterOptions(data: any[]): { types: string[], statuses: string[], country: string[] } {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return { types: [], statuses: [], country: [] };
    }

    const types = Array.from(new Set(data.map(item => item?.Type).filter(type => type)));
    const statuses = [...Array.from(new Set(data.map(item => (item?.CustomerStatus || item?.Status)).filter(status => status))), 'Completed'];
    const country = Array.from(new Set(data.map(item => item?.Country).filter(country => country)));
    
    return { types, statuses, country };
  }

  // getTableFilterData(type: any, status: any, country: any) {
  //   // Defensive: always use arrays for filters
  //   const safeType = Array.isArray(type) && type.length > 0 ? type : ['all'];
  //   const safeStatus = Array.isArray(status) && status.length > 0 ? status : ['all'];
  //   const safeCountry = Array.isArray(country) && country.length > 0 ? country : ['all'];
  //   this.spinBool = true;
  //   this.qnSbnService.getNotificationOverviewData(safeType, safeStatus, safeCountry).subscribe({
  //     next: (response: any) => {
  //       const data = response?.notificationOverview || [];
  //       this.ogTableData = [...data];
  //       this.tableData = this.applySorting(data);
  //       this.searchInput(this.searchValueSel || '');
  //       this.currentPage = 0; // Reset to first page
  //       this.updatePaginatedData();
  //       this.filterBool = this.tableData.length === 0;
  //       this.searchBool = false;
  //       this.spinBool = false;
  //       this.changeDetect.detectChanges();
  //     },
  //     error: () => {
  //       this.initPageLoad = true;
  //     }
  //   });
  // }

  searchInput(searchValueSel: any): void {
    const searchString = searchValueSel.toLowerCase().trim();
    const filteredData = this.ogTableData.filter((ite:any) => {
      return this.appUtils.getLowerCase(ite.Type).includes(searchString) ||
             this.appUtils.getLowerCase(ite.GlobalId).includes(searchString) ||
             this.appUtils.getLowerCase(ite.LocalId).includes(searchString) ||
             this.appUtils.getLowerCase(ite.Country).includes(searchString) ||
             this.appUtils.getLowerCase(ite.Title).includes(searchString) ||
             this.appUtils.getLowerCase(ite.CreationDate).includes(searchString) ||
            //  this.appUtils.getLowerCase(ite.CustomerName || ite.AccountName || '').includes(searchString) ||
            //  this.appUtils.formatDateOnly(ite.DateDelivered || '').toLowerCase().includes(searchString) ||
            //  this.appUtils.formatDateOnly(ite.FeedbackDueDate || '').toLowerCase().includes(searchString) ||
             this.appUtils.getLowerCase(ite.CustomerStatus || ite.Status || '').includes(searchString);
    });
  
    this.tableData = this.applySorting(filteredData);
    this.currentPage = 0; // Reset to first page
    this.updatePaginatedData();
    this.searchBool = this.tableData.length === 0;
    this.filterBool = false;
    this.changeDetect.detectChanges();
  }

  public OnSort(column: string, value: string): void {
  
    const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
    if (existingSortIndex !== -1) {
      this.sortInfo.splice(existingSortIndex, 1);
    }
    if (value !== 'default') {
      this.sortInfo.push({ column, direction: value });
    }
    // Use current tableData (which may be filtered) instead of ogTableData
    this.tableData = this.applySorting(this.tableData);
    this.updatePaginatedData();
    this.changeDetect.detectChanges();
  }

  applySorting(data: any[]): any[] {
    const dataCopy = [...data];
    if (this.sortInfo.length > 0) {
      return dataCopy.sort((a, b) => {
        for (let i = this.sortInfo.length - 1; i >= 0; i--) {
          const { column, direction } = this.sortInfo[i];
          const aValue = a[column] ?? '';
          const bValue = b[column] ?? '';
          if (aValue < bValue) return direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return dataCopy;
  }

  openLocalNotificationDialog() {
    this.router.navigateByUrl('/create-local-notification');
  }

  // Helper method to create clean copies of row data to prevent circular references
  private createCleanRowData(row: any): any {
    if (!row) return {};
    
    try {
      const visited = new WeakSet();
      
      const deepClone = (obj: any): any => {
        // Handle primitive types
        if (obj === null || typeof obj !== 'object') {
          return obj;
        }
        
        // Prevent circular references
        if (visited.has(obj)) {
          return undefined;
        }
        
        // Handle arrays
        if (Array.isArray(obj)) {
          visited.add(obj);
          const arr = obj.map(item => deepClone(item)).filter(item => item !== undefined);
          visited.delete(obj);
          return arr;
        }
        
        // Handle dates
        if (obj instanceof Date) {
          return obj.toISOString();
        }
        
        // Handle objects
        visited.add(obj);
        const cloned = {};
        
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            
            // Skip functions and undefined values
            if (typeof value === 'function' || value === undefined) {
              continue;
            }
            
            // Recursively clone safe properties
            if (value === null || typeof value !== 'object') {
              cloned[key] = value;
            } else if (Array.isArray(value)) {
              cloned[key] = value.map(item => deepClone(item)).filter(item => item !== undefined);
            } else if (!(value instanceof Date) && !visited.has(value)) {
              cloned[key] = deepClone(value);
            }
          }
        }
        
        visited.delete(obj);
        return cloned;
      };
      
      return deepClone(row);
    } catch (error) {
      console.error('Error creating clean row data:', error);
      // Fallback to basic structure if deep clone fails
      return {
        NotificationId: row?.NotificationId,
        LocalId: row?.LocalId,
        Subject: row?.Subject,
        Status: row?.Status,
        Title: row?.Title,
        Type: row?.Type
      };
    }
  }

  openNotificationDetails(row) {
    // Don't set reloadOverview to true - we want to preserve state when navigating back
    // sessionStorage.setItem('reloadOverview','true');
    
    // Validate input
    if (!row || !row.NotificationId) {
      console.error('Invalid row data provided to openNotificationDetails');
      return;
    }

    // Create a clean copy of the row data to prevent circular references
    const cleanRowData = this.createCleanRowData(row);
    
    if(row.Status == 'Draft' && (this.userPermission.CreateNotification || this.userPermission.SendNotification)) {
      this.qnSbnDataService.resetAll();
      this.qnSbnService.getNotificationContactDetails(row.NotificationId).subscribe(
        (newdata:any) => {
          if(newdata.length > 0) {
            const recipientData = []
            newdata.forEach(element => {
              if (element) {
                recipientData.push({
                  customerId: element.CustomerId,
                  customerName: element.CustomerName,
                  customerContactName: element.CustomerContactName,
                  customerEmail: element.CustomerContactEmail,
                  sourceName: element.DataSource
                });
              }
            });
            const sourceName = [...new Set(newdata.map(x => x?.DataSource).filter(Boolean))];

            let sourceEle = [];
            sourceName.forEach(source => {
              if (source) {
                sourceEle.push({label: source, value: source})
              }
            });
            this.qnSbnDataService.getMappedQnsbnData({ 
              recipientTable: recipientData,
              sourceName: sourceEle
            },"Recipient")
          }
        },
        (error: HttpErrorResponse) => {
          this.qnSbnService.httpErrorHandler(error, 'Could not fetch contact details.');
        }
      );

      this.qnSbnService.setLocalNotificationID(row.LocalId);
      this.qnSbnDataService.getMappedQnsbnData(cleanRowData,"DraftNotification");
      this.qnSbnDataService.getMappedQnsbnData(
        {
          "NotificationId": row.NotificationId,
          "Type": row.Type,
          "Title": row.Title,
          "GlobalId": row.GlobalId,
          "Country": row.Country,
          "GlobalNotificationId": row.GlobalNotificationId,
          "CreationDate": row.CreationDate,
          "LocalId": row.LocalId,
          "Status": row.Status,
          "UserId": row.UserId,
          "UserRole": row.UserRole,
          "LocalNotificationLanguage": row.LocalNotificationLanguage
        },"LocalNotificationId");
      if(row.NotificationDocuments && row.NotificationDocuments[0]) {
        this.qnSbnDataService.getMappedQnsbnData(row.NotificationDocuments[0],"NotificationDoc");
      }
      if(row.CustomerFeedbackItems) {
        const feedbackData = [];
        row.CustomerFeedbackItems.forEach(element => {
          feedbackData.push({
            dragHandle: '',
            selectType: element.FeedbackItemType,
            selectText: element.FeedbackItemLabel,
            selectMandatory: element.FeedbackItemMandatory || 'Mandatory',
            iconSets: 'more-icon',
            dropDownOpt: element.FeedbackItemDropdown || [],
            radioOpt: element.FeedbackItemRadio || []
          });
        });
        this.qnSbnDataService.getMappedQnsbnData(feedbackData,"ConfigureFeedBack");
      }
      if(row.MessageTitle || row.MessageBody)
        this.qnSbnDataService.getMappedQnsbnData({
          "subjectName":row.MessageTitle,
          "messageAttachmentRTEText":row.MessageBody,
          "templateId": row.TemplateId || ""
        },"MessageAttachment");
      if(row.NotificationAttachments) {
        const fileList = [];
        let fileSize = 0;
        row.NotificationAttachments.forEach(element => {
          const filetype = element.FileName.split('.').pop();
          fileSize = fileSize + element.FileSize;
          if(element.NotificationDoc) {
            this.qnSbnDataService.getMappedQnsbnData([{
              name: element.FileName,
              size: element.FileSize,
              type: filetype,
              fileIcon: this.appUtils.formatFilesIcons(filetype)
            }],"NotificationDocFileList");
          } else {
            fileList.push(<any>{
              name: element.FileName,
              size: element.FileSize,
              type: filetype,
              fileIcon: this.appUtils.formatFilesIcons(filetype)
            });
          }
        });
        this.qnSbnDataService.getMappedQnsbnData({
          "fileList": fileList,
          "totalAllFileSize": fileSize,
          "fileSizeobject": {}
        },"MessageAttachmentFileList");
      }
      if(row.FeedbackDueDate)
        this.qnSbnDataService.getMappedQnsbnData({
          "feedbackDueDate":row.FeedbackDueDate
        },"FeedbackDueDate");
      if(row.NotificationReminders) {
        const reminderData = [];
        row.NotificationReminders.forEach(element => {
          reminderData.push({
            reminderDate: element.ReminderDueDate,
            reminderSubject: element.ReminderSubject,
            reminderMessage: element.ReminderMessage,
            reminderSendMode: element.ReminderSendAutomatically? '0' : '1',
            reminderActionIcons: true
          });
        });
        this.qnSbnDataService.getMappedQnsbnData({
          "remindersData":reminderData      
        },"NotificationReminders"); 
      }
      this.router.navigateByUrl('/create-notification', { state: { notificationData: cleanRowData } });
    } else {
      this.qnSbnService.getNotificationContactDetails(row.NotificationId).subscribe(
        (data:any) => {
          // Create clean copies of the data to prevent circular references using deep clone
          const cleanContactData = Array.isArray(data) 
            ? data.map(item => this.createCleanRowData(item)) 
            : [];

          this.qnSbnService.getAccountList(row.NotificationId).subscribe(
            res =>{
              const cleanAccountData = Array.isArray(res?.body) 
                ? res.body.map(item => this.createCleanRowData(item)) 
                : [];
              this.router.navigateByUrl('/notification-details', { 
                state: { 
                  notificationData: cleanRowData, 
                  contactData: cleanContactData, 
                  accountDataObj: cleanAccountData 
                } 
              });
            },
            (err: HttpErrorResponse) => {
              this.qnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
            }
          );
    
        },
        (error: HttpErrorResponse) => {
          this.qnSbnService.httpErrorHandler(error, 'Could not fetch contact details.');
          this.router.navigateByUrl('/notification-details', { 
            state: { 
              notificationData: cleanRowData, 
              contactData: [], 
              accountDataObj: [] 
            } 
          });
        }
      );
    }
  }


   updatePaginatedData(): void {
  
    if (this.cachedDataLocked) {
     
      return;
    }
    
    this.totalCount = this.tableData?.length || 0;
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.tableData?.slice(startIndex, endIndex) || [];
  
  }


  get startIndex(): number {
    return this.currentPage * this.pageSize + 1;
  }

  get endIndex(): number {
    const end = (this.currentPage + 1) * this.pageSize;
    return Math.min(end, this.totalCount);
  }

  get totalPages(): number {
    return Math.ceil(this.totalCount / this.pageSize);
  }

  onPageSizeChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.pageSize = parseInt(target.value, 10);
    this.currentPage = 0;
    this.updatePaginatedData();
    this.changeDetect.detectChanges();
  }

  goToPreviousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePaginatedData();
      this.changeDetect.detectChanges();
    }
  }

  goToNextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.updatePaginatedData();
      this.changeDetect.detectChanges();
    }
  }

  goToFirstPage(): void {
    this.currentPage = 0;
    this.updatePaginatedData();
    this.changeDetect.detectChanges();
  }

  goToLastPage(): void {
    this.currentPage = this.totalPages - 1;
    this.updatePaginatedData();
    this.changeDetect.detectChanges();
  }
}

